/**
 * Generates a random number between the specified minimum and maximum values (inclusive).
 * @param min The minimum value that the generated number can be.
 * @param max The maximum value that the generated number can be.
 * @returns A random number between the specified minimum and maximum values (inclusive).
 */
export const randomNumber = (min: number, max: number): number => {
  return Math.round(Math.random() * (max - min) + min);
};
